export const PERMISSIONS = {
  ruleConfig: 'Rebate.RuleConfig',
  generalRule: 'Rebate.RuleConfig.GenernalRule',
  divisionRule: 'Rebate.RuleConfig.DivisionRule',
  specialRefund: 'Rebate.SpecialRefund',
  reports: 'Rebate.Reports',
  tasks: 'Rebate.Tasks',
  users: 'AbpIdentity.Users',
  roles: 'AbpIdentity.Roles',
  permissions: 'AbpIdentity.Permissions',
  dictCategory: 'Rebate.DictCategory',
  dictDetail: 'Rebate.DictDetail',
  systemConfig: 'Rebate.SystemConfig',
  priceProtection: 'Rebate.PriceProtection',
  emailTemplate: 'Rebate.EmailTemplate',
  watermarkParse: 'Rebate.WatermarkParse',
  externalReport: 'Rebate.ExternalReport',
  actionLog: 'Rebate.ActionLog',
  apiLog: 'Rebate.ApiLog',
  auditLog: 'Rebate.AuditLog',
  connectPointManagement: 'Rebate.ManualUploadFile',
} as const;

export const MENU_ACCESS = {
  rule: 'canSeeRuleMenu',
  report: 'canSeeReportMenu',
  task: 'canSeeTaskMenu',
  system: 'canSeeSystemMenu',
  log: 'canSeeLogMenu',
} as const;

export const ACCESS_REDIRECTS = {
  '/rule': [
    { access: PERMISSIONS.ruleConfig, path: '/rule/ruleConfig' },
    { access: PERMISSIONS.specialRefund, path: '/rule/specialRefund' },
    {
      access: PERMISSIONS.connectPointManagement,
      path: '/rule/connectPointManagement',
    },
  ],
  '/report': [{ access: PERMISSIONS.reports, path: '/report/index' }],
  '/task': [{ access: PERMISSIONS.tasks, path: '/task/index' }],
  '/system': [
    { access: PERMISSIONS.users, path: '/system/user' },
    { access: PERMISSIONS.roles, path: '/system/role' },
    { access: PERMISSIONS.permissions, path: '/system/permission' },
    { access: PERMISSIONS.dictCategory, path: '/system/dictionary' },
    { access: PERMISSIONS.systemConfig, path: '/system/config' },
    { access: PERMISSIONS.priceProtection, path: '/system/priceProtection' },
    { access: PERMISSIONS.emailTemplate, path: '/system/email' },
    { access: PERMISSIONS.watermarkParse, path: '/system/watermarkParse' },
    { access: PERMISSIONS.externalReport, path: '/system/externalReport' },
  ],
  '/log': [
    { access: PERMISSIONS.actionLog, path: '/log/operation' },
    { access: PERMISSIONS.apiLog, path: '/log/interface' },
    { access: PERMISSIONS.auditLog, path: '/log/audit' },
  ],
} as const;

const getRedirectAccesses = (path: keyof typeof ACCESS_REDIRECTS) =>
  ACCESS_REDIRECTS[path].map((item) => item.access);

export const MENU_PERMISSION_GROUPS = {
  [MENU_ACCESS.rule]: getRedirectAccesses('/rule'),
  [MENU_ACCESS.report]: getRedirectAccesses('/report'),
  [MENU_ACCESS.task]: getRedirectAccesses('/task'),
  [MENU_ACCESS.system]: getRedirectAccesses('/system'),
  [MENU_ACCESS.log]: getRedirectAccesses('/log'),
} as const;

export const ROUTE_PERMISSION_CODES = Object.values(PERMISSIONS);
